import { hasWindow } from 'src/utils/hasWindow'

export const isPage = (page: string, pathname?: string) => {
  if (hasWindow()) {
    return (pathname || window.location.pathname).replaceAll('/', '') === page.replaceAll('/', '')
  }
  return false
}
